import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'wsg-card-container',
  templateUrl: './card-container.component.html',
  styleUrls: ['./card-container.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardContainerComponent {

  @Input() noMarginTop = false;
  @Input() headerText = '';
  @Input() icon = '';
  @Input() noHeader = false;
  @Input() displayStyle = 'block';
  @Input() helpVideoName = '';
}
